"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1Strong: function() {
        return _index.Body1Strong;
    },
    body1StrongClassNames: function() {
        return _index.body1StrongClassNames;
    }
});
const _index = require("./components/presets/Body1Strong/index");
